import styled from 'styled-components';
export const Image = styled.img`
  width: 33px;
  height: 33px;
  border-radius: 100%;
  object-fit: contain;
`;